import api from './api';

const technologyStackMasterService = {
  // Get all technology stack masters with pagination and filters
  getAllTechnologyStackMasters: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      
      // Add pagination parameters
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      
      // Add filter parameters
      if (params.search) queryParams.append('search', params.search);
      if (params.status) queryParams.append('status', params.status);
      if (params.category) queryParams.append('category', params.category);
      if (params.type) queryParams.append('type', params.type);
      
      const response = await api.get(`/technology-stack-masters?${queryParams.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching technology stack masters:', error);
      throw error;
    }
  },

  // Get technology stack master by ID
  getTechnologyStackMasterById: async (id) => {
    try {
      const response = await api.get(`/technology-stack-masters/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching technology stack master:', error);
      throw error;
    }
  },

  // Create new technology stack master
  createTechnologyStackMaster: async (technologyStackMasterData) => {
    try {
      const response = await api.post('/technology-stack-masters', technologyStackMasterData);
      return response.data;
    } catch (error) {
      console.error('Error creating technology stack master:', error);
      throw error;
    }
  },

  // Update technology stack master
  updateTechnologyStackMaster: async (id, technologyStackMasterData) => {
    try {
      const response = await api.put(`/technology-stack-masters/${id}`, technologyStackMasterData);
      return response.data;
    } catch (error) {
      console.error('Error updating technology stack master:', error);
      throw error;
    }
  },

  // Delete technology stack master (soft delete)
  deleteTechnologyStackMaster: async (id) => {
    try {
      const response = await api.delete(`/technology-stack-masters/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting technology stack master:', error);
      throw error;
    }
  },

  // Get technology stack master statistics
  getTechnologyStackMasterStats: async () => {
    try {
      const response = await api.get('/technology-stack-masters/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching technology stack master stats:', error);
      throw error;
    }
  }
};

export default technologyStackMasterService;
